var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./ArchivesCollections.jinja');
require('./ArchivesCollections.less');

module.exports = Base.extend({

    template: template,

    events: {
        'click .ArchivesCollections-block': 'toggleBlock'
    },


    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    },


    toggleBlock: function (e) {
        var $block = $(e.currentTarget);
        var rolledClass = '.ArchivesCollections-blockRolled';
        var activeModifier = 'ArchivesCollections-block--active';

        if ($(e.target).closest(rolledClass).length) return;

        if ($block.hasClass(activeModifier)) {
            $block.find(rolledClass).slideUp(200);
            $block.removeClass(activeModifier);
        } else {
            $block.find(rolledClass).slideDown(200);
            $block.addClass(activeModifier);
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/ArchivesCollections/ArchivesCollections.js
// module id = 158
// module chunks = 0